import { useState, useContext, useEffect } from "react";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import AddTable from "../../screens/Colaboradores/Colaboradores/CollaboratorTab/AddTable";
import SearcherTable from "../../screens/Colaboradores/Colaboradores/CollaboratorTab/SearcherTable";
import TableBits from "../TableBits/TableBits";
import NewsOptionsField from "./Fields/NewsOptionsField";
import { NewsContext } from "../../context/NewContext/NewContext";
import ProjectsField from "../Notification/Fields/ProjectsField";
import TitleField from "./Fields/TitleField";
import DateField from "./Fields/DateField";
import AuthorField from './Fields/AuthorField'
import { useQuery, useLazyQuery } from "@apollo/client";
import { GET_ALL_NOTICES } from "../../Querys/querys";
import CheckPermission from "../../helpers/Administradores/Permissions";

const columns: any = [
  { id: "fecha", label: "Fecha", align: "left" },
  { id: "autor", label: "Autor", align: "left" },
  { id: "tittle", label: "Título", align: "left" },
  { id: "projects", label: "Proyectos", align: "left" },
];

const Body = () => {
  const [news, setNews] = useState<Array<any>>([]);
  const [newsFilter, setNewsFilter] = useState<Array<any>>([]);
  const {  state, dispatch } = useContext(NewsContext);
  const [getNews, { data: resultDataNews }] = useLazyQuery(GET_ALL_NOTICES,{
    fetchPolicy:'no-cache'
  });

  useEffect(() => {
    if (resultDataNews && resultDataNews.GET_ALL_NOTICES) {
      setNews(resultDataNews.GET_ALL_NOTICES);
      setNewsFilter(resultDataNews.GET_ALL_NOTICES);
    }
  }, [resultDataNews]);

  useEffect(()=>{
    console.log(state.delete);
    if(!state.isOpen || !state.delete){
      getNews();
    }
  }, [state.isOpen, state.delete]);

  

  return (
    <Box display="flex" flexDirection="column" p={2}>
      <Box p={1} pb={3} display="flex" flexDirection="row">
        <Grid container justify="flex-start">
          <SearcherTable
            initState={news}
            setState={setNewsFilter}
            label={"Buscar por Autor / titulo / proyecto(s) "}
            fields={["autor", "tittle", "Descripcion", "projects", "customDate"]}
            width={400}
          />
        </Grid>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          style={{ width: "100%" }}
        >
          {CheckPermission("Noticias.Crear") && (
            <AddTable
              func={() => dispatch({ type: "OPEN_MODAL" })}
              img={"icono-agregar-event.svg"}
              text={"Crear nueva noticia"}
            />
          )}
        </Box>
      </Box>

      <TableBits
        columns={columns}
        rows={newsFilter}
        components={[DateField, AuthorField ,TitleField , ProjectsField]}
        componentOptions={NewsOptionsField}
        customInitialOrder={'desc'}
      />
    </Box>
  );
};

export default Body;
